import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../pages/Footer";
import DasboardNavbar from "./DasboardNavbar"; // Import your sidebar/navbar component

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // State to manage sidebar visibility
  const [isMobileView, setIsMobileView] = useState(false); // Detect if it's mobile view
  const location = useLocation();
  const [user1, setUser1] = useState();

  // Retrieve user email and name from location state or default empty values
  const [userName, setUserName] = useState(location.state?.userName || '');
  const [userEmail, setUserEmail] = useState(location.state?.userEmail || '');

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };
  // Helper function to check if token is expired
  const isTokenExpired = (token) => {
    try {
      const decodedToken = JSON.parse(atob(token.split('.')[1])); // Decode the JWT payload
      const expiryTime = decodedToken.exp * 1000; // Convert expiry to milliseconds
    
      return Date.now() > expiryTime; // Compare current time with token expiry time
    } catch (error) {

      return true; // Treat token as expired if decoding fails
    }
  };

  // Function to clear cookies and localStorage
  const clearUserData = () => {
    const domain = window.location.hostname === 'localhost' ? 'localhost' : '.jobbox.one';

    // Clear cookies
    document.cookie = `user=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    document.cookie = `token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

    // Clear localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };
  useEffect(() => {
    const tokenFromCookies = getCookie('token');  // Check token from cookies
    const userFromCookies = getCookie('user');  // Check user from cookies
   
    // First check if token exists in cookies or localStorage
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));

    const loginUrl =
      window.location.hostname === "localhost"
        ? "http://localhost:3000/hr-sign-in"
        : "https://app.jobbox.one/hr-sign-in";

   const userCookies = userFromCookies ? JSON.parse(userFromCookies) : null;



// Final check
if (
  !tokenFromCookies ||
  isTokenExpired(tokenFromCookies) ||
  !userCookies?.userRole ||
  userCookies.userRole.toLowerCase() !== 'hr'
) {
  clearUserData();
 // alert("Something's wrong with your session.");
  window.location.href = loginUrl;
  return;
}

    // If token is valid, set user data and proceed
    setUser1(userCookies);
    // If userName or userId is empty, fetch from URL query parameters or localStorage
    if (!userName.trim() || !userEmail) {
      const urlParams = new URLSearchParams(location.search);
      const urlUserName = urlParams.get('userName');
      const urlUserEmail = urlParams.get('userEmail');
      if (urlUserName) {
        setUserName(decodeURIComponent(urlUserName));  // Decode the userName from URL
      } else {
        setUserName(user ? user.userName : null);
      }
      if (urlUserEmail) {
        setUserEmail(decodeURIComponent(urlUserEmail));  // Decode the userId from URL
      } else {
        setUserEmail(user ? user.urlUserEmail : null);
      }
    }
  }, [userName, userEmail, location.search]);

  useEffect(() => {
    const storedUserName = localStorage.getItem(`userName_${userEmail}`);
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, [userEmail]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1200) { // 768px is the breakpoint for mobile view
        setIsMobileView(true);
        setIsSidebarOpen(false); // Ensure sidebar is closed on mobile by default
      } else {
        setIsMobileView(false);
        setIsSidebarOpen(true); // Keep sidebar open for larger screens
      }
    };

    // Listen for window resize
    window.addEventListener("resize", handleResize);
    handleResize(); // Run once to set the initial state

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobileView) {
      setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar visibility for mobile
    } else {
      setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar visibility for larger screens
    }
  };

  const handleLinkClick = () => {
    if (isMobileView) {
      setIsSidebarOpen(false); // Close the sidebar on mobile when clicking outside
    }
  };

  // User object to pass to HrLeftSide
  const user = {
    userName: userName,
    userEmail: userEmail,
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <div style={{ display: "flex", flex: 1 }}>
        {/* Left Side: Sidebar */}
        <div
          style={{
            width: isSidebarOpen ? (isMobileView ? "10%" : "14%") : "0", // For mobile, sidebar takes 80% width when open
            height: "100%",
            overflowY: "auto",
            backgroundColor: "#f8f9fa",
            position: isMobileView ? "absolute" : "relative", // Sidebar should overlay content on mobile
            zIndex: isMobileView ? "1000" : "auto", // Ensure sidebar appears above content on mobile
            transition: "width 0.3s ease-in-out", // Smooth transition for larger screens        
            //  marginLeft: isSidebarOpen ? "0" : "10px", // Add margin-left when sidebar is closed
          }}
        >
          <DasboardNavbar user={user1} isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>

        {/* Right Side: Main Content */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            marginTop: "80px",
            marginLeft: isMobileView ? "0" : isSidebarOpen ? "0" : "0", // No margin for mobile; adjust for sidebar on larger screens
            width: "100%", // Right side content always takes full width
            transition: isMobileView ? "none" : "margin-left 0.3s ease-in-out", // Smooth transition only on larger screens
          }}
          onClick={handleLinkClick}
        >
          {children}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
